module.exports = __webpack_public_path__ + "img/奖章1级@2x.fa447776.png";